import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-gray-800 mt-12">
            <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
                    {/* Copyright Section */}
                    <p className="text-gray-400 text-sm mb-4 md:mb-0">
                        &copy; {new Date().getFullYear()} SearchTec Notes. All rights reserved.
                    </p>

                    {/* Navigation Links */}
                    <div className="flex space-x-6">
                        <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors">
                            About
                        </Link>
                        <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">
                            Contact
                        </Link>
                        <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                            Privacy Policy
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;